var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeautyEarthandPlanetElements11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.62px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m141.26,110.84c2.35-6.11,3.65-12.74,3.65-19.68,0-7.82-1.64-15.26-4.6-21.99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.94,89.35s.06,0,.09,0c0-.26,0-.53.02-.79-.04,0-.09,0-.13,0,.01.26.01.53.02.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.99,91.16c0-.61.03-1.21.05-1.81-.03,0-.06,0-.09,0,.02.6.05,1.2.05,1.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.77,88.55c-19.2-.46-35.95-10.77-45.38-26.09-4.71-7.65-7.6-16.55-8.04-26.09,9.77.21,18.92,2.96,26.79,7.64,10.09,5.99,18.08,15.13,22.64,26.06,0,0-22.5,7.2-35.71-18.59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m143.8,36.34c-9.76,0-18.92,2.56-26.86,7.03-15.97,9-26.99,25.76-27.89,45.18.35,0,.69.03,1.04.03,19.75,0,37.06-10.45,46.7-26.12,4.71-7.66,7.6-16.55,8.04-26.09-.35,0-.69-.03-1.04-.03Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.94,89.66s.06,0,.09,0c0,.26,0,.53.02.79-.04,0-.09,0-.13,0,.01-.26.01-.53.02-.79Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.99,87.85c0,.61.03,1.21.05,1.81-.03,0-.06,0-.09,0,.02-.6.05-1.2.05-1.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.39,116.54c-4.71,7.65-7.6,16.55-8.04,26.09,9.77-.21,18.92-2.96,26.79-7.64,15.38-9.14,25.9-25.58,26.79-44.54-19.26.4-36.08,10.73-45.53,26.09Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.73,107.76c4.62,11.84,13.25,21.68,24.22,27.86,7.94,4.47,17.09,7.03,26.86,7.03.35,0,.69-.02,1.04-.03-.45-9.54-3.33-18.44-8.04-26.09-9.65-15.67-26.95-26.12-46.7-26.12-.12,0-.24,0-.35,0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.74,110.84c-2.35-6.11-3.65-12.74-3.65-19.68,0-7.82,1.64-15.26,4.6-21.99"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.16,38.74c6.11-2.35,12.74-3.65,19.68-3.65,7.82,0,15.26,1.64,21.99,4.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.16,141.26c6.11,2.35,12.74,3.65,19.68,3.65,7.82,0,15.26-1.64,21.99-4.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyEarthandPlanetElements11);
export default __webpack_public_path__ + "static/media/Beauty, Earth and Planet Elements-11.075f18f52fa3cb3889874990bcfea5a2.svg";
export { ForwardRef as ReactComponent };